// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__Lajgb","shimmer":"Skeleton_shimmer__tAUKT"};